import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { memo } from 'react';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { RouteNaming } from 'z3k-settings/routes/type';
import { getZ3kEntityById } from 'z3k-parser/lib';
import { useAppSelector } from 'shared/hooks/redux/hooks';
function LinkRouter(props) {
    const { mobileflag, ...rest } = props;
    return (_jsx(Link, { ...rest, sx: {
            ...(mobileflag && {
                color: 'white',
            }),
        }, component: RouterLink }));
}
export const BreadCrumbs = memo(function BreadCrumbs(props) {
    const location = useLocation();
    const item_id = location.state?.item_id;
    let namePage = null;
    if (item_id && props.config) {
        const [type, obj] = getZ3kEntityById(props.config, item_id);
        //@ts-ignore
        namePage = obj?.name;
    }
    const pathnames = location.pathname
        .split('/')
        .filter((x) => x)
        .slice(1);
    const is_staff = useAppSelector((state) => state.account.is_staff);
    return (_jsx(Breadcrumbs, { "aria-label": "breadcrumb", separator: _jsx(Typography, { sx: {
                ...(props.mobileFlag
                    ? { color: 'white' }
                    : { color: 'primary.main' }),
            }, variant: "h6", children: '•' }), sx: {
            '& .MuiBreadcrumbs-ol': {
                justifyContent: 'center',
            },
        }, children: pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `${pathnames.slice(0, index + 1).join('/')}`;
            return last ? (_jsx(Typography, { variant: "subtitle2", children: namePage != null
                    ? `${namePage}${is_staff ? ' (' + item_id + ')' : ''}`
                    : // @ts-ignore
                        RouteNaming[value] ?? value }, to)) : (_jsx(LinkRouter, { underline: "hover", to: to, variant: "subtitle1", mobileflag: props.mobileFlag, children: RouteNaming[value] ?? value }, to));
        }) }));
});
